<script lang="ts" setup>
import type { OfferImage } from '~/types/Catalog';

defineProps<{ images: OfferImage[] }>();

const isShowFullscreenGallery = ref(false);
const selectedSlideIndex = ref(0);

function openFullscreenGallery(imageIndex?: number) {
  isShowFullscreenGallery.value = true;
  selectedSlideIndex.value = imageIndex ?? 0;
}
</script>

<template>
  <div
    v-if="images.length"
    class="product-feedback-images"
  >
    <button
      v-for="(image, key) in images.slice(0, 2)"
      :key="image.url"
      class="product-feedback-images__image-thumbnail"
      name="question image"
      @click="openFullscreenGallery(key)"
    >
      <picture>
        <source
          :srcset="image.conversions_webp.thumb_url_560"
          type="image/webp"
        />
        <img
          :src="image.url"
          alt="user's image"
        />
      </picture>
    </button>

    <button
      v-if="images.length > 2"
      class="product-feedback-images__image-thumbnail product-feedback-images__image-thumbnail--more"
      name="more question images"
      @click="openFullscreenGallery(2)"
    >
      +{{ images.length - 2 }}
    </button>

    <FullscreenImageGallery
      v-model:is-show="isShowFullscreenGallery"
      v-model:selected-slide-index="selectedSlideIndex"
      :images="images"
      alt="user's image"
    />
  </div>
</template>

<style lang="scss" scoped>
.product-feedback-images {
  display: flex;
  gap: 8px;

  &__image-thumbnail {
    display: flex;
    justify-content: center;
    align-items: center;
    object-fit: cover;
    overflow: hidden;
    width: 60px;
    height: 60px;
    border-radius: 8px;
    background-color: $white;
    transition: all 0.3s;

    &--more {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-right: 8px;
      background-color: $black-10;
      font-size: $text-lg;
    }

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
